import { type ReactNode, forwardRef, useId, useMemo } from 'react';

import { FormControl, type FormControlProps } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

import { useFormFieldContext } from './FormField.ctx';
import { FormFieldItemContext } from './FormFieldItem.ctx';

export type FormFieldItemProps = {
  children?: ReactNode;
  id?: string;
  formControlProps?: FormControlProps;
};

export const FormFieldItem = forwardRef<HTMLDivElement, FormFieldItemProps>(
  ({ ...props }, ref) => {
    const id = useId();
    const fieldContext = useFormFieldContext();
    const { getFieldState, formState } = useFormContext();

    const fieldState = getFieldState(fieldContext.name, formState);

    const contextValue = useMemo(() => ({ id }), [id]);

    return (
      <FormFieldItemContext.Provider value={contextValue}>
        <FormControl
          ref={ref}
          isInvalid={!!fieldState.error}
          display="flex"
          flexDirection="column"
          isRequired={fieldContext.optionalityHint === 'required'}
          isDisabled={fieldContext.isDisabled}
          id={props.id}
          gap={1}
          {...props.formControlProps}
        >
          {props.children}
        </FormControl>
      </FormFieldItemContext.Provider>
    );
  }
);
FormFieldItem.displayName = 'FormItem';
